import { render, staticRenderFns } from "./RightNowVistor.vue?vue&type=template&id=2a2e2928&scoped=true&"
import script from "./RightNowVistor.vue?vue&type=script&lang=js&"
export * from "./RightNowVistor.vue?vue&type=script&lang=js&"
import style0 from "./RightNowVistor.vue?vue&type=style&index=0&id=2a2e2928&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2e2928",
  null
  
)

component.options.__file = "RightNowVistor.vue"
export default component.exports